import TopNav from './Navigation/TopNav'

export default function Navigation({
  saveIsCurrent = null,
  setSaveIsCurrent = null,
}) {
  return <TopNav saveIsCurrent={saveIsCurrent} setSaveIsCurrent={setSaveIsCurrent} />
}
